<template>
    <keep-alive>
         <div class="modal-mask">
            <div class="modal-wrapper">
                <div class="modal_size md_size">
                    <a href="JavaScript:" class="ui_close" type="button" @click="$emit('close')"><span class="sr_only">popup close</span></a>
                    <dl class="modal_content">
                        <dt class="ellipsis">
                            <i>Search User</i>
                        </dt>
                        <dd>
                            <div class="srchModal_wrap">
                                <div class="dl_search_pop">
                                    <dd data-input-type="select" class="sech">
                                        <dt class="tit">{{$t('FIELD.SURVEY.SUMMARY.USER_NAME')}}</dt>
                                        <dt data-input-type="select" class="sel">
                                            <input class="w90" type="text" v-model="loginName" @keyup.enter.stop="onSearch()">
                                        </dt>
                                    </dd>
                                    <dd data-input-type="select" class="sech">
                                        <dt class="tit">{{$t('FIELD.FAQ.CORP')}}</dt>
                                        <dt data-input-type="select" class="sel">
                                            <select class="slt_white w40p" v-model="rhqCd" @change="changeRhqCd()">
                                                <option value='' selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option v-for="code in rhqCdList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                            <select class="slt_white w40p" v-model="corpNo">
                                                <option value='' selected>{{$t('FIELD.FAST.DURATION.ALL')}}</option>
                                                <option v-for="code in corpNoList" :key="code.code" :value="code.code">{{code.codeName}}</option>
                                            </select>
                                        </dt>
                                    </dd>
                                </div>
                                <div class="srch_grupR">
                                    <span class="btn">
                                    <a href="JavaScript:" class="btn_srch" @click="onSearch()">{{$t('BUTTON.GLOBAL.SEARCH')}}</a>
                                    </span>
                                </div>
                            </div>
                            <div class="grid_wrap">
                                <div class="grid_total">
                                    {{$t('TITLE.TOTAL.COUNT')}} : <em>{{ resultCount | numberFormat }}</em>
                                </div>
                                <div class="grid_wrap mt-10">
                                    <toast-grid
                                        :gridId="gridId"
                                        :columns="columns"
                                        :data="gridData"
                                        :options="options"
                                        :ref="gridId"
                                        :key="gridKey"
                                        :pageOptions="pageOptions"
                                        :isTotalCount="false"
                                        :click="contentClick"
                                    />
                                </div>
                            </div>
                            <!-- detail_Authorization-->
                            <table class="create_table mt20" v-if="menuMode">
                                <colgroup>
                                    <col width="25%" />
                                    <col width="*" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>{{$t('FIELD.AUTHREQ.AUTH')}}</th>
                                        <td>
                                            <label class="radiobox-wrap ">
                                                <input type="radio" name="creationYn" v-model="creationYn" value="N" checked="" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.ONLY.VIEW')}}</em>
                                            </label>
                                            <label class="radiobox-wrap">
                                                <input type="radio" name="creationYn" v-model="creationYn" value="Y" />
                                                <i class="radio-icon"></i>
                                                <em>{{$t('FIELD.GLOBAL.CREATION')}}</em>
                                            </label>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <dd class="scroll_btm">
                                <div class="btn_modal_wrap topLine">
                                    <div class="btn_right">
                                        <a href="JavaScript:" class="btn_white" title @click="$emit('close')">{{$t('BUTTON.GLOBAL.CANCEL')}}</a>
                                        <a href="JavaScript:" class="btn_blue" title @click="userSave()">{{$t('BUTTON.GLOBAL.SELECT')}}</a>
                                    </div>
                                </div>
                            </dd>
                        </dd>
                    </dl>
                </div>
            </div>
        </div>
    </keep-alive>
</template>
<script>
import Vue from 'vue';
import qs from 'query-string';
import axios from 'axios';
import { SDLUtil } from '@/utils';
import { EventBus } from '@/utils/EventBus';
import ToastGrid from '~c/ToastGrid';
import { mapGetters } from 'vuex';
import api from '@/service';

// Toast Grid Custom Renderer
class CheckButtonType {
    constructor(props) {
        const el = document.createElement('input');
        el.setAttribute('type', 'checkbox');
        el.setAttribute('name', 'checkbox');
        el.classList.add('check-icon');
        this.el = el;
    }
    getElement() {
        return this.el;
    }
}

export default {
    name: 'searchModelPopup',
    components: {
        'toast-grid': ToastGrid,
    },
    computed: {
        ...mapGetters({
            loginNo: 'getLoginNo',
        }),
        getLoginNo() {
            return this.loginNo || '';
        },
    },
    props: {
        'pAuthCorpId': { type: String, default: '' },
        'pAuthId': { type: String, default: '' },
        'pRhqCdList': { type : Array, default : [] },
        'pCorpNoList': { type : Array, default : [] },
        'pMenuMode' : { type: Boolean, default: false },
        rtnUserFunc: { type: Function }
    },
    data() {
        return {
            gridId: 'searchPopupGrid',
            loginName: '',
            rhqCd: '',
            corpNo: '',
            authCorpId: this.pAuthCorpId,
            authId: this.pAuthId,
            menuMode : this.pMenuMode,
            creationYn: 'N',
            rhqCdList: this.pRhqCdList,
            corpNoList: this.pCorpNoList,
            selectList: [],
            gridKey: 0,
            resultCount: 0,
            columns: [
                {
                    header: 'Check',
                    name: '',
                    align: 'center',
                    width: 50,
                    resizable: true,
                    sortable: false,
                    renderer: { type: CheckButtonType }
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.GLOBAL.LOGIN.ID'),
                    name: 'LOGINID',
                    width: 250,
                    sortable: false
                },
                {
                    header: SDLUtil.getMsgProp('FIELD.SURVEY.SUMMARY.USER_NAME'),
                    name: 'LOGINNAME',
                    width: 250,
                    sortable: false
                },
                {
                    header: 'Email',
                    name: 'EMAIL',
                    width: 50,
                    hidden: true,
                    sortable: false
                }
            ],
            gridData: [],
            options: {
                scrollY: false,
                scrollX: false,
                minBodyHeight: 80,
                bodyHeight: 318,
                rowHeight: 25,
                // rowHeaders: ['checkbox'],
            },
            pageOptions: {
                useClient: true,
                perPage: 8,
            },
        };
    },
    methods: {
        async getCodeComboList(categoryVal, categoryCode) {
            const codeResp = await api.getComboList(categoryVal, categoryCode, this.getLoginNo);
            return codeResp;
        },
        loadSubsiCodes(pCode) {
            this.getCodeComboList(pCode, 'SUB_AUTH_ACCESS_CD').then(data => {
                this.corpNoList = data;
            });
        },
        prepSearchParams(exclude = []) {
            let params = {
                page: 1,
                currentPage: 1,
                perPage: '99999',
                loginName: this.loginName,
                rhqCd: this.rhqCd,
                corpNo: this.corpNo
            };
            console.log('search.params ==> ', params);
            return params;
        },
        async onSearch() {
            const formData = this.prepSearchParams();

            SDLUtil.showLoadingBar(true);
            return await axios
                .post(`${SDLUtil.API_URL}/basis/admin/system/userRole/roleUsersPopup.skp`, 
                    qs.stringify(formData), {
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded',
                    },
                    params: { searchInfo: 'set' },
                })
                .then(resp => {
                    this.resultCount = resp.data.totalCount;
//                    console.log('pop.resp.data ==> ', resp.data);
                    this.gridData = resp.data.rows;
                    this.gridKey++;
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    Vue.$log.error(err);
                    SDLUtil.errorAlert(err);
                    SDLUtil.showLoadingBar(false);
                });
        },
        // RhqCd 변경 시..
        changeRhqCd() {
            this.loadSubsiCodes(this.rhqCd);
        },
        // Save 버튼 클릭 시...
        userSave() {
            if (this.selectList.length == 0) {
                SDLUtil.alert('MESSAGE.GROBAL.NOSELECT');
                return;
            } else {
                if (this.menuMode) { // 안물어보고 바로 실행
                    this.rtnUserFunc(this.selectList, this.creationYn);
                    this.$emit('close');
                } else { // 예의상 한번 물어봄.
                    SDLUtil.confirm({
                        msg: 'MESSAGE.HME.SUBMIT.CONFIRM',
                        title: 'BUTTON.GLOBAL.SAVE',
                        onOkEvt: () => {
                            this.rtnUserFunc(this.selectList, this.creationYn);
                            this.$emit('close');
                        },
                    });
                }
            }
        },
        removeList(logino) {
            let newList = [];
            this.selectList.forEach(elm => {
                if (logino != elm) {
                    newList.push(elm);
                }
            });
            this.selectList = newList;
        },
        contentClick(e, rowData, grid) {
            let curRowKey = e.rowKey;
            if (curRowKey > this.pageOptions.perPage) {
                curRowKey = e.rowKey % this.pageOptions.perPage;
            }
            let loginNo = rowData[e.rowKey]['LOGINNO'];
            let loginId = rowData[e.rowKey]['LOGINID'];
            let loginNm = rowData[e.rowKey]['LOGINNAME'];
            let email   = rowData[e.rowKey]['EMAIL'];
            const key = loginNo + '^' + loginId + '^' + loginNm + '^' + email;

            if ($('.check-icon')[curRowKey].checked) {
                this.selectList.push(key);
            } else {
                this.removeList(key);
            }
        },
    },
    mounted() {
        console.log('this.pRhqCdList ===> ', this.pRhqCdList);
        this.rhqCd = this.rhqCdList[0].code;
        this.onSearch();
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/system/userRole/UserAddPopup.vue